var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center py-32 px-8"},[_c('exclamation-circle-icon',{staticClass:"w-full mb-4 text-red-600",attrs:{"size":"6x"}}),_c('div',{staticClass:"font-semibold text-2xl mb-24 w-full"},[_vm._v("결제가 정상적으로 처리되지 않았습니다.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }